import { Component, OnInit } from '@angular/core';
import { InfoService } from 'src/app/service/info.service';
import { LoginService } from 'src/app/service/login.service';
import { ParametrosService } from 'src/app/service/parametros.service';
@Component({
  selector: 'app-centros-atencion',
  templateUrl: './centros-atencion.component.html',
  styleUrls: ['./centros-atencion.component.scss']
})
export class CentrosAtencionComponent implements OnInit {

  session: any;
  dni: string;
  constructor(private parametrosService: ParametrosService, private login: LoginService) {
    this.session = JSON.parse(localStorage.getItem('sesionPocae'))
  }

  msjError: any;
  numParametro: number;
  centros: any[]
  filter = '';
  error: boolean;
  loading: boolean;
  noResults: boolean;

   async ngOnInit() {
    this.numParametro = 26004;
    this.error = false;
    this.msjError = '';
    this.loading = false;

    await this.getCentros();
  }

  async getCentros() {
    this.loading = true;
    try {
      const res = await this.parametrosService.fetchParametros(this.numParametro);

      if (!res || !res.ok) {
        this.error = true;
        this.msjError = res?.message || 'Error al obtener datos';
        this.centros = [];
      } else {        
        const data = (res as any).data || {};
        this.noResults = false;
        if (Array.isArray(data.parametros) && data.parametros.length) {
           this.centros = data.parametros.filter(
            (p: any) => p.sIndicador01 === 'S' && p.sIndicador02 === 'S'
          );
          this.noResults = this.centros.length === 0;
        } else {
          // fallback: si el body viene en otro shape, inspección mínima
          this.centros = data || [];
          this.noResults = true;
        }
        this.error = false;
      }
    } catch (err) {
      console.error('Error getCentros', err);
      this.error = true;
      this.msjError = 'Error inesperado';
      this.centros = [];
    } finally {
      this.loading = false;
    }
  }
}